<template>
    <div>
        <canvas ref="qrcodeCanvas" style="border-radius: 10px;"></canvas>
    </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
    name: "QrCode",
    props: {
    text: {
      type: String,
      required: true
    },
    key:{
        type:Number,
        required:true
    }
  },
    methods: {
        generateQRCode() {
            const canvas = this.$refs.qrcodeCanvas

            // console.log('generateQRCode')
            // console.log(this.text)

            QRCode.toCanvas(canvas, this.text, error => {
                if (error) console.error(error)
            })
        }

    },
    mounted() {
        // console.log('QrCode.vue——m')

        this.generateQRCode()
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>